import * as ActionTypes from "./ActionTypes";

export const SetTapeBillInfo = billInfo => {
  return {
    type: ActionTypes.APPSTATE_SET_TAPE_BILL_INFO,
    billInfo: billInfo
  };
};

export const SetMachineInfo = machineInfo => {
  return {
    type: ActionTypes.APPSTATE_SET_MACHINE_INFO,
    machineInfo: machineInfo
  };
};

export const StartLoading = (isTransparent, updateStorage) => {
  return {
    type: ActionTypes.APPSTATE_START_LOADING,
    isLoading: true,
    isTransparent: isTransparent,
    shouldUpdateLocalStorage: updateStorage
  };
};

export const StopLoading = updateStorage => {
  return {
    type: ActionTypes.APPSTATE_STOP_LOADING,
    isLoading: false,
    shouldUpdateLocalStorage: updateStorage
  };
};

export const ChangeServerStatus = (code, updateStorage) => {
  return {
    type: ActionTypes.APPSTATE_SERVER_CHANGE_STATUS,
    serverStatusCode: code,
    shouldUpdateLocalStorage: updateStorage
  };
};

export const SetLiveTheme = (themeID, updateStorage) => {
  return {
    type: ActionTypes.APPSTATE_CHANGE_CURRENT_LIVE_THEME,
    themeID: themeID,
    shouldUpdateLocalStorage: updateStorage
  };
};

export const SetLanguage = (languageCode, updateStorage) => {
  return {
    type: ActionTypes.APPSTATE_SET_LANGUAGE,
    languageCode: languageCode,
    shouldUpdateLocalStorage: updateStorage
  };
};

export const SetSettingsPickerVisibility = (isShown, updateStorage) => {
  return {
    type: ActionTypes.APPSTATE_SHOWS_SETTINGS_PICKER,
    isShown: isShown,
    shouldUpdateLocalStorage: updateStorage
  };
};

export const SetLanguagePickerVisibility = (isShown, updateStorage) => {
  return {
    type: ActionTypes.APPSTATE_SHOWS_LANGUAGE_PICKER,
    isShown: isShown,
    shouldUpdateLocalStorage: updateStorage
  };
};

export const SetNumericKeyboardVisibility = (isShown, updateStorage) => {
  return {
    type: ActionTypes.APPSTATE_SHOWS_NUMERIC_KEYBOARD,
    isShown: isShown,
    shouldUpdateLocalStorage: updateStorage
  };
};

export const SetOddFormat = (oddFormatID, updateStorage) => {
  return {
    type: ActionTypes.APPSTATE_SET_ODD_FORMAT,
    oddFormatID: oddFormatID,
    shouldUpdateLocalStorage: updateStorage
  };
};

export const SetSortType = (sortID, updateStorage) => {
  return {
    type: ActionTypes.APPSTATE_SET_SORT_TYPE,
    sortID: sortID,
    shouldUpdateLocalStorage: updateStorage
  };
};

export const ChangePrinterStatuses = (statuses, updateStorage) => {
  return {
    type: ActionTypes.APPSTATE_SET_PRINTER_STATUSES,
    statuses: statuses,
    shouldUpdateLocalStorage: updateStorage
  };
};

export const SetNewRollLength = newLengthMM => {
  return {
    type: ActionTypes.APPSTATE_SET_NEW_ROLL_LENGTH,
    newLengthMM: newLengthMM
  };
};



// WEBPACK FOOTER //
// ./src/ReduxStore/Actions/AppStateActions.js